import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

export default class TopBarMenuLinks extends PureComponent {
  static propTypes = {
    title: PropTypes.string.isRequired,
    icon: PropTypes.string.isRequired,
    path: PropTypes.string.isRequired,
  };

  render() {
    const { title, icon, path } = this.props;

    return (
      <Link className="topBar__link" to={path}>
        <span className={`topBar__link-icon lnr lnr-${icon}`} />
        <p className="topBar__link-title">{title}</p>
      </Link>
    );
  }
}
